export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '/air-ticket/admin/',
      component: () => import('@/page/distributor/component/admin-layout/index.vue'),
      children: [
        {
          path: '/air-ticket/admin/purchase-order-list',
          name: 'air-ticket-admin-purchase-order-list',
          component: () => import('./1.0.1/index.vue'),
          meta: {
            nav_list_for_admin_layout_head_nav: [
              {name: `国内机票订单`},
              {name: `我的订单`},
            ]
          },
        },
      ]
    },
  ]
};

